import { MAP_ID, ZOOM_LEVEL, STROKE_COLOR, STROKE_WIDTH, PLACE_MARK_ICON_COLOR, PLACE_MARK_PRESET } from '../../maps/config';
import getCoordinates from "./coordinates";

/**
 * @function initYandexMap - рисует карту маршрута поезда
 * @param {YaMap} ymaps - глобальный объект предоставляющий доступ к карте
 * */

export default function initYandexMap(ymaps = {}) {
    if (!ymaps.hasOwnProperty('Map')) {
        setTimeout(initYandexMap, 100, window.ymaps);
        return;
    }

    const coords = getCoordinates(points);

    /** @var {YaMiniMap} miniMap */
    const miniMap = new ymaps.Map(MAP_ID, { center: [ points[0].latitude, points[0].longitude ], zoom: ZOOM_LEVEL });

    const routeCoordsConfig = {
        geometry: {
            type: "LineString",
            coordinates: coords
        }
    };
    const routeCoordsStyles = {
        draggable: false,
        strokeColor: STROKE_COLOR,
        strokeWidth: STROKE_WIDTH
    };

    const routeObjectsTargetCoords = new ymaps.GeoObject(routeCoordsConfig, routeCoordsStyles);

    miniMap.geoObjects.add(routeObjectsTargetCoords);

    for (let i = 0; i < points.length; i++) {
        const {arrival_time, departure_time, local_arrival_time, local_departure_time} = points[i];
        const { waiting_time, latitude, longitude } = points[i];

        let content = `${points[i].name} <br>`;
        const arrive = arrival_time ? `Прибытие: ${arrival_time} <br>` : '';
        const depart = departure_time ? ` Отправление: ${departure_time}  <br>` : '';
        const waiting = parseInt(waiting_time) ? ` Стоянка: ${parseInt(waiting_time)} мин` : '';

        content += arrive + depart + waiting;

        const hasLocalTime = local_arrival_time && local_departure_time;
        const areTimeZonesDifferent = local_arrival_time !== arrival_time || local_departure_time !== departure_time;

        if (hasLocalTime && areTimeZonesDifferent) {
            content += `<br> Местное время прибытия ${local_arrival_time} <br>`;
            content += `Местное время отправления ${local_departure_time}`;
        }

        miniMap.geoObjects.add(
            new ymaps.Placemark(
                [latitude, longitude],
                {balloonContent: content},
                {preset: PLACE_MARK_PRESET, iconColor: PLACE_MARK_ICON_COLOR}
            ),
        );
    }

    miniMap.setBounds(miniMap.geoObjects.getBounds());
}
